import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Divider.module.scss';

// eslint-disable-next-line
export const spacingPropTypes = PropTypes.oneOf(['xxSmall', 'xSmall', 'small', 'medium', 'large', 'xLarge', 'xxLarge', 'xxxLarge']);
export const spacingDefaultProps = 'medium';

const Divider = ({ className, labelClassName, spacing, children }) => (
  <div className="row">
    <div className="col-12">
      <hr className={cn(styles[spacing], className)} />
      {children && (
        <div className={cn(styles.label, labelClassName)}>

          <span>{children}</span>
        </div>
      )}
    </div>
  </div>
);

Divider.propTypes = {
  spacing: spacingPropTypes
};

Divider.defaultProps = {
  spacing: spacingDefaultProps
};

export default Divider;
